import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { errMsg } from "@/lib/api";

const STATUS = { client: "has a client login", invited: "invited, no login yet", new: "will get a new client login" };

export const EmailToClient = ({ api, period, cover }) => {
  const [rows, setRows] = useState(null);
  const [pick, setPick] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/reports/family/recipients").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [api]);
  const ids = Object.keys(pick).filter((k) => pick[k]);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post("/reports/family/share", { period, entity_ids: ids, ...cover });
      r.data.results.forEach((x) => (x.sent
        ? toast.success(`Book emailed to ${x.name} (${x.email})`)
        : toast.error(`${x.name || "Not sent"}: ${x.reason}`)));
      setPick({});
      setRows((await api.get("/reports/family/recipients")).data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="border-t border-slate-200 pt-4" data-testid="family-book-email-section">
      <div className="small-label">Email to client</div>
      {rows && rows.length === 0 && (
        <p className="text-xs text-slate-500 mt-2" data-testid="family-book-no-recipients">No one has a client email yet. Add one on the person in Entities (pencil icon).</p>
      )}
      <div className="space-y-2 mt-2">
        {(rows || []).map((p) => (
          <label key={p.id} className={`flex items-start gap-2 text-sm ${p.blocked ? "opacity-60" : ""}`} data-testid={`family-book-recipient-${p.id}`}>
            <Checkbox className="mt-0.5" disabled={!!p.blocked} checked={!!pick[p.id]} onCheckedChange={(c) => setPick({ ...pick, [p.id]: !!c })} data-testid={`family-book-recipient-check-${p.id}`} />
            <span className="min-w-0">
              <span className="text-slate-900">{p.name}</span> <span className="text-slate-500 break-all">· {p.email}</span>
              <span className="block text-xs text-slate-500">{p.blocked || STATUS[p.status]}</span>
            </span>
          </label>
        ))}
      </div>
      {rows && rows.length > 0 && (
        <Button variant="outline" className="rounded-sm mt-3 w-full" disabled={!ids.length || busy} onClick={send} data-testid="family-book-email-send">
          <Mail className="h-4 w-4 mr-2" />{busy ? "Sending…" : `Email book to ${ids.length || ""} client${ids.length === 1 ? "" : "s"}`.replace("  ", " ")}
        </Button>
      )}
      <p className="text-[11px] text-slate-500 mt-2">The email has no attachment. Each client signs in to a private portal and gets a personal book: their own statement plus the trusts and companies they own.</p>
    </div>
  );
};
